import { render } from "./billingSettingView.vue?vue&type=template&id=d8820b96&scoped=true"
import script from "./billingSettingView.vue?vue&type=script&lang=js"
export * from "./billingSettingView.vue?vue&type=script&lang=js"

import "./billingSettingView.vue?vue&type=style&index=0&id=d8820b96&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8820b96"]])

export default __exports__